export const CIA_TRIAD = {
  confidentiality: "confidentiality",
  integrity: "integrity",
  availability: "availability",
  performance: "performance",
  privacy: "privacy",
  safety: "safety",
} as const;
